import BtWorklist from '@/components/bt-worklist/index'
import BtRealApproval from '@/components/bt-realization/BtRealizationApproval'
import BtRealizationExpense from '@/components/bt-realization/BtRealizationExpense'
import BtRealizationExpenseNew from '@/components/bt-realization/BtRealizationExpenseNew'
import BtRealizationExpenseDetail from '@/components/bt-realization/BtRealizationExpenseDetail'
import BtReqApproval from '@/components/business-trip/BusinessTripRequestApproval'
import BusinessTripRequestEmployees from '@/components/business-trip/BusinessTripRequestEmployees'
import BusinessTripRequestEmployeeDetail from '@/components/business-trip/BusinessTripRequestEmployeeDetail'
import BusinessTripRequestExpenseDetail from '@/components/business-trip/BusinessTripRequestExpenseDetail'
import BusinessTripRequestExpense from '@/components/business-trip/BusinessTripRequestExpense'
import BusinessTripRequestExpenseNew from '@/components/business-trip/BusinessTripRequestExpenseNew'
import BusinessTripRequestEmployeeNew from '@/components/business-trip/BusinessTripRequestEmployeeNew'
import Worklist from '@/components/bt-worklist/Worklist'

const BTWorklistRouter = [
  {
    path: 'worklist',
    name: 'Worklist',
    component: Worklist,
    props: true
  },
  {
    path: 'worklist/:worklistid',
    name: 'business-trip-worklist',
    component: BtWorklist,
    props: true,
    children: [{
      path: 'bt-approval',
      component: BtRealApproval,
      props: true,
      children: [
        {
          path: '',
          name: 'business-trip-realization-approval',
          component: BtRealizationExpense
        },
        {
          path: 'new-expense',
          name: 'bt-realization-approval-new-expense',
          component: BtRealizationExpenseNew,
          props: true
        },
        {
          path: 'detail-expense',
          name: 'bt-realization-approval-expense-detail',
          component: BtRealizationExpenseDetail,
          props: true
        }
      ]
    },
    {
      path: 'bt-approval',
      component: BtReqApproval,
      props: true,
      children: [
        {
          path: '',
          name: 'business-trip-request-approval',
          component: BusinessTripRequestEmployees
        }
      ]
    },
    {
      path: 'bt-request/:id/:empid',
      name: 'bt-approval-reqemp-detail',
      component: BusinessTripRequestEmployeeDetail,
      props: true
    },
    {
      path: 'bt-request/:id',
      name: 'bt-approval-reqemp-new',
      component: BusinessTripRequestEmployeeNew,
      props: true
    },
    {
      path: 'bt-request/:id/:empid/expense',
      name: 'bt-approval-reqexpense',
      component: BusinessTripRequestExpense,
      props: true
    },
    {
      path: 'bt-request/:id/:empid/new-expense',
      name: 'bt-approval-reqexpense-new',
      component: BusinessTripRequestExpenseNew,
      props: true
    },
    {
      path: 'bt-request/:id/:empid/:expid',
      name: 'bt-approval-reqexpense-detail',
      component: BusinessTripRequestExpenseDetail,
      props: true
    }]
  }
]

export default BTWorklistRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripWorklistRouter.js